import { KeyboardEvent } from 'react';

import type { BaseUIEvent } from '@base-ui/react/types';

// With the popup closed base-ui clears the whole selection on Escape; block it
// so Escape never wipes a committed value.
export const blockEscapeSelectionClear = (event: BaseUIEvent<KeyboardEvent>, isOpen: boolean) => {
  if (event.key === 'Escape' && !isOpen) {
    event.preventBaseUIHandler();
  }
};

// base-ui also writes to the input itself — echoing a committed selection,
// resetting it when the popup closes ('input-clear'), emptying it from the
// clear button ('clear-press') — and none of those is the user editing the
// query.
export const isUserInputEdit = (reason: string) => reason === 'input-change';
